/**
 * No-Match Selection Reader
 *
 * Reads the current product name + chosen option rows from the live variations
 * form, for the no-match modal's "your current selection" context card.
 * Extracted from no-match-notice.js so the modal module stays focused on
 * presentation (and under the 350-line ceiling).
 *
 * Rules:
 *  - Skips hidden / .rps-auto-hidden rows.
 *  - Skips the turnaround row (a TAV delivery time, not a product option that
 *    makes a combination invalid).
 *  - Strips the theme's .selected-value span from the row label so TAV's chosen
 *    turnaround text doesn't bleed into the label (e.g. "Turnaround2 Business Days").
 *
 * @package HaruVariationsPro
 * @version 1.0.0
 */

/**
 * @returns {{name: string, rows: Array<{label: string, value: string}>}}
 */
export function readCurrentSelection() {
    const titleEl = document.querySelector('.product_title, h1.product_title, .product .entry-title');
    const name = titleEl ? titleEl.textContent.trim() : ((window.hvpData && window.hvpData.productName) || '');

    const rows = [];
    const form = document.querySelector('form.variations_form');
    if (form) {
        form.querySelectorAll('table.variations tr').forEach((tr) => {
            if (tr.style.display === 'none' || tr.classList.contains('rps-auto-hidden')) {
                return;
            }
            if (tr.querySelector('select[name*="turnaround"], .tav-custom-interface')) {
                return;
            }
            const sel = tr.querySelector('select[name^="attribute_"]');
            let value = '';
            if (sel && sel.selectedIndex >= 0) {
                value = (sel.options[sel.selectedIndex].textContent || '').trim();
            } else {
                const li = tr.querySelector('ul li.selected');
                if (li) {
                    const tip = li.querySelector('.haru-tooltip');
                    value = (tip ? tip.textContent : li.textContent).trim();
                }
            }
            let label = '';
            const labelCell = tr.querySelector('td.label');
            if (labelCell) {
                const clone = labelCell.cloneNode(true);
                clone.querySelectorAll('.selected-value').forEach((n) => n.remove());
                label = clone.textContent.replace(/[:：]\s*$/, '').trim();
            }
            if (label && value) {
                rows.push({ label, value });
            }
        });
    }
    return { name, rows };
}

export default readCurrentSelection;
